import { get } from 'lodash';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import axiosService from '../../../services/axiosRequestBuilder';
import history from '../../../services/history';
import * as types from '../types';
import * as actions from './actions';

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function* loginRequest({ payload }) {
  try {
    const {
      token,
      codeVerify,
      clientId,
      redirect,
      clientSecret,
      tokenEndpoint,
      loginProvider,
    } = payload;

    const axios = axiosService.getInstance();

    const response = yield call(axios.post, 'Auth/login', {
      token,
      codeVerify,
      clientId,
      redirect,
      clientSecret,
      tokenEndpoint,
      loginProvider,
    });

    yield put(actions.loginSuccess(response.data));

    sessionStorage.removeItem('auth_error_redirect');

    axios.defaults.headers.Authorization = `Bearer ${response.data.token}`;

    history.push('/loading');
  } catch (error) {
    sessionStorage.setItem('auth_error_redirect', 'true');
    yield call(delay, 5000);
    history.push('/access-denied');
  }
}

function persistRehydrate({ payload }) {
  const axios = axiosService.getInstance();
  const token = get(payload, 'auth.token', '');
  if (!token) return;
  axios.defaults.headers.Authorization = `Bearer ${token}`;
}

export default all([
  takeLatest(types.LOGIN_REQUEST, loginRequest),
  takeLatest(types.PERSIST_REHYDRATE, persistRehydrate),
]);
